import React, { useEffect, useState } from "react";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useForm } from "react-hook-form";
import Config from "../../common/data/api.service";
import formFieldResolvers from "../../common/forms/resolvers";
import FormSection from "../common/forms/sections";
import ButtonInputField from "../common/forms/fields/input.button";
import toast from "react-hot-toast";
import { Banner } from "../common/banner";
import UserAccountRoles, { ACCOUNT_ROLE_LIST } from "./user.roles";
import { ACCOUNT_ROLE } from "../../common/data/constants";
import { USER_ROLE } from "../../common/utils/constants";

const UserRolesForm = ({ userToUpdate, setUserToUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const authUser = useAuthUser();
  const isOwnAccount = authUser?.uuid === userToUpdate?.uuid;

  const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm({
    resolver: formFieldResolvers.rolesForm,
  });

  const selectedRole = watch("roles") || userToUpdate?.roles[0];

  useEffect(() => {
    if (userToUpdate) {
      setIsEditing(true);
      Object.entries(userToUpdate)?.forEach(([key, value]) =>
        setValue(key, key === "roles" ? value[0] : value)
      );
    }
  }, [userToUpdate, setValue]);

  const handleFormSubmit = ({ roles }) => {
    Config.PROD_REMOTE_API.put(
      `users/${userToUpdate?.uuid}/roles?role=${roles}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${authUser?.access_token}`,
        },
      }
    )
      .then((response) => response.data)
      .then((response) => {
        if (response?.success) {
          toast.success(response?.message);
        } else {
          toast.error("Account role failed to update: " + JSON.stringify(response));
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.errors[0]);
        console.log(error?.response?.data);
        throw new Error(error?.message);
      });
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)} className="flex flex-col">
      <FormSection
        className="py-3"
        title="Manage account roles"
        subTitle="This setting determines what this account can do in the system."
        show={true}
      >
        <Banner text="Only admin accounts can update roles and permissions. Also, these accounts cannot re-assign themselves other roles." />

        {/* All roles in one component for single-click selection */}
        {!isOwnAccount && authUser?.roles?.includes(ACCOUNT_ROLE.ROLE_ADMIN) && (
          <UserAccountRoles
            errors={errors}
            roles={ACCOUNT_ROLE_LIST}       // all roles
            setValue={setValue}             // immediately update form state
            register={() => register("roles")}
            defaultRole={selectedRole}      // pre-select current role
          />
        )}
      </FormSection>

      <FormSection
        className="py-1.5"
        show={authUser?.roles.includes(USER_ROLE.ADMIN)}
      >
        <div className="flex flex-row">
          <ButtonInputField type="submit" value="Save changes" />
        </div>
      </FormSection>
    </form>
  );
};

export default UserRolesForm;
